export default __webpack_public_path__ + "static/media/appStatusLOPending.42d7637f.png";